(function () {
  // Swiper 14 injects default chevron SVGs (addIcons: true) into empty
  // .swiper-button-next/prev. Theme already draws arrows via CSS ::before
  // or icon-caret — disable injection globally so every Swiper instance
  // keeps the pre-upgrade arrow look without per-init config churn.
  if (typeof Swiper !== 'undefined' && typeof Swiper.extendDefaults === 'function') {
    Swiper.extendDefaults({
      navigation: {
        addIcons: false
      }
    });
  }

  let cardSliderObserver = null;
  const observedCardSliders = new Set();

  const promote = (slide) => {
    if (!slide) return;
    slide.querySelectorAll('img[data-src], img[data-srcset]').forEach((image) => {
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }
      if (image.dataset.src) {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }
    });
  };

  const init = (container) => {
    if (container.swiper) return;
    const parent = container.closest('.card__media');
    if (!parent) return;
    const nextEl = parent.querySelector('.swiper-button-next');
    const prevEl = parent.querySelector('.swiper-button-prev');
    const paginationEl = parent.querySelector('.swiper-pagination');
    const slideCount = container.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
    const swiper = new Swiper(container, {
      loop: slideCount > 1,
      slidesPerView: 1,
      a11y: true,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      // Only wire navigation when both controls exist (empty/missing = no nav).
      ...(nextEl && prevEl
        ? {
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
              addIcons: false
            }
          }
        : {})
    });
    container.swiper = swiper;

    const slides = swiper.slides;
    const i = swiper.activeIndex;
    const n = slides.length;
    promote(slides[i]);
    promote(slides[(i - 1 + n) % n]);
    promote(slides[(i + 1) % n]);

    swiper.on('slideChange', () => {
      const s = swiper.slides;
      const j = swiper.activeIndex;
      const m = s.length;
      promote(s[j]);
      promote(s[(j - 1 + m) % m]);
      promote(s[(j + 1) % m]);
      swiper.pagination && swiper.pagination.update();
    });
  };

  Shopify.cardProductSlider = function (el) {
    let containers = document.querySelectorAll(el);

    // RUCSP-89: collection product-grid .prod-images-slider use only interaction
    // hydration (never IO or no-IO eager). One handler per uninit container,
    // guarded vs dup on AJAX/cardProductSlider repeats.
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      productGrid.querySelectorAll('.prod-images-slider').forEach((container) => {
        if (container.swiper || container.dataset.interactionHydrated) return;
        container.dataset.interactionHydrated = 'true';
        const focusTarget = container.closest('.card-wrapper') || container;
        const hydrate = () => {
          if (container.swiper) return;
          init(container);
          if (cardSliderObserver) cardSliderObserver.unobserve(container);
          observedCardSliders.delete(container);
          container.removeEventListener('mouseenter', hydrate);
          focusTarget.removeEventListener('focusin', hydrate);
          container.removeEventListener('touchstart', hydrate);
        };
        container.addEventListener('mouseenter', hydrate);
        focusTarget.addEventListener('focusin', hydrate);
        container.addEventListener('touchstart', hydrate, { passive: true });
      });
    }

    // Never pass collection product-grid .prod-images-slider to IO/eager.
    containers = Array.from(containers).filter(
      (c) => !(productGrid && c.closest('#product-grid') && c.classList.contains('prod-images-slider'))
    );

    // Lazy-hydrate: only initialise a card's slider when it nears the viewport.
    if (!('IntersectionObserver' in window)) {
      containers.forEach(init);
      return;
    }

    if (!cardSliderObserver) {
      cardSliderObserver = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              init(entry.target);
              obs.unobserve(entry.target);
              observedCardSliders.delete(entry.target);
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
    }

    observedCardSliders.forEach((container) => {
      if (!container.isConnected) {
        cardSliderObserver.unobserve(container);
        observedCardSliders.delete(container);
      }
    });

    containers.forEach((container) => {
      if (!container.swiper && !observedCardSliders.has(container)) {
        cardSliderObserver.observe(container);
        observedCardSliders.add(container);
      }
    });
  };
})();
